import React, { useEffect } from 'react'
import ModalBasic from '../../components/infrastructure/Modals/ModalBasic'
import { useFormik } from 'formik';
import { editEmployee, fetchEmployee } from '../../app/reducers/Users/EmployeeSlice';
import { useDispatch } from 'react-redux';
import FormikInputGroup from '../../components/formik/FormikInputGroup';
import { object, string } from 'yup';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import { toast } from 'react-toastify';

function ChangePasswordModal({ openChangePasswordModal, setOpenChangePasswordModal, userId }) {
    const dispatch = useDispatch();

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            password: '',
            confirmPassword: '',
        },
        validationSchema: object({
            password: string().required(),
            confirmPassword: string().required(),
        }),
        onSubmit: async (values) => {
            try {
                const password = values?.password;
                const confirmPassword = values?.confirmPassword;
                if (password !== confirmPassword) {
                    formik.resetForm();
                    return alert("Password not Matched")
                }
                const payload = {
                    _id: userId,
                    password: values.password,
                };
                const resp = await dispatch(editEmployee(payload));
                console.log("resp:::", resp);
                if (resp?.payload?.success) {
                    formik.resetForm();
                    setOpenChangePasswordModal(false);
                }
            } catch (error) {
                console.log(error);
                toast.error("Fail to ChangePasswordModal");
            }

        },
    });

    useEffect(() => {
        dispatch(fetchEmployee({ _id: userId }));
    }, [userId]);


    return (
        <>
            <ModalBasic
                title="Change Password"
                modalOpen={openChangePasswordModal}
                setModalOpen={setOpenChangePasswordModal}
            >
                <div className="p-4">
                    <form
                        onSubmit={formik.handleSubmit}
                        className='flex flex-col gap-4'
                    >
                        <FormikInputGroup
                            type="password"
                            formik={formik}
                            label="Password"
                            name="password"
                        />

                        <FormikInputGroup
                            type="password"
                            formik={formik}
                            label="Confirm Password"
                            name="confirmPassword"
                        />
                        <div>
                            <PrimaryButton type="submit">Update Password</PrimaryButton>
                        </div>
                    </form>
                </div>
            </ModalBasic>
        </>
    )
}

export default ChangePasswordModal